<div>
  <div class="list-info">
    <h4>Custo total estimado</h4>
    <p>{{infoProjeto?.value}}</p>
  </div>

  <div class="header_search m-t-xl">
    <div class="title-page">
      <h3>Produto</h3>
    </div>
    <div class="content_search">
      <div class="new-project">
        <a class="btn btn-primary" type="btn" *ngIf="permission?.can_create" [routerLink]="novo()">Novo</a>
      </div>
    </div>
  </div>

  <div class="system-table table-container">
    <div class="system-table-conteiner">
      <table>
        <thead>
          <tr>
            <th>Cód.</th>
            <th>Produto</th>
            <th class="text-center">Unid. Med.</th>
            <th class="text-center">Meta</th>
            <th class="text-center">Custo Estimado</th>
            <th class="text-center">Tempo</th>
            <th class="text-center">Modalidade</th>
            <th class="text-center">Etapa e/ou documento concluídos</th>
            <th class="text-center btn-icon-td">Ações</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of produtoList">
            <tr>
              <td class="title">{{item?.code}}</td>
              <td><span class="title-span">{{item?.description}}</span></td>
              <td class="text-center">{{item?.unit_id}}</td>
              <td>{{item?.ds_goal}}</td>
              <td class="text-center">{{item?.value}}</td>
              <td class="text-center">{{item?.exec_duration}}</td>
              <td class="text-center">{{item?.prod_template_name}}</td>
              <td class="text-center">{{item?.step_finished_names}}</td>
              <td>
                <div class="btn-icon" *ngIf="permission?.can_edit">
                  <a class="icon-table" [routerLink]="editar(item?.id)">
                    <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
                  </a>
                </div>
              </td>
            </tr>
          </ng-container>

          <tr *ngIf="produtoList?.length" class="border-b-radius">
            <td class="title-width" colspan="4"><span class="title-span">Totais</span></td>
            <td class="text-center">{{total}}</td>
            <td class="text-center" colspan="3"></td>
            <td></td>
          </tr>

          <tr *ngIf="!produtoList?.length" class="border-b-radius">
            <td colspan="9" class="text-center">Nenhum Produto Cadastrado.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-xxl-8 col-lg-10 col-sm-12 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-danger m-r-xxl" *ngIf="idProjeto && permission?.can_delete" (click)="confirmExcluir()" type="button">Excluir</button>
        <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
        <button class="btn btn-white m-r-xs" *ngIf="idProjeto" type="button" (click)="imprimir()">Imprimir</button>
        <button class="btn btn-white m-r-xs" *ngIf="idProjeto && permission?.can_clone" type="button" (click)="openCloneModal()">Clonar</button>
      </div>
    </div>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>

<ng-template #modalClone>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Clonar processo</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeCloneModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body table-form">
    <div class="form-group row">
      <div class="col-sm-12 m-b">
        <label class="col-sm-12 pb-1">Novo Nome</label>
        <input class="form-control" [(ngModel)]="clone_title" maxlength="300">
      </div>
    </div>
    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-xxl-8 col-lg-10 col-sm-12 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="closeCloneModal()">Fechar</button>
        <button class="btn btn-primary" type="button" [disabled]="!clone_title" (click)="clonar()">Clonar</button>
      </div>
    </div>
  </div>
</ng-template>